// const baseURL = 'http://localhost:8100/'
// const baseURL = '//www.kaiy.vip/byfile/'
const baseURL = '//www.b100y.com/b100yxueyuan/'
// const baseBackURL = '//localhost:8080/baiyiCollege/'
// const baseBackURL = 'http://server.kaiy.vip:8080/baiyiCollege/'
// const baseBackURL = 'http://www.kaiy.vip:8080/baiyiCollege/'
const baseBackURL = '//www.b100y.com/baiyiCollege/'
// const baseURL = 'http://119.3.233.183:8139/'
// const baseBackURL = 'http://119.3.233.183:8239'

export default {
  baseURL,
  baseBackURL
}
//



// WEBPACK FOOTER //
// ./src/utils/global_variable.js